import React from 'react';
import PropTypes from 'prop-types';
import Row from 'kepler/lib/components/Row';
import Col from 'kepler/lib/components/Col';
import Button from 'kepler/lib/components/Button';
import getContent from '../lib/dictionaryFetcher';
import DeveloperProduct from './DeveloperProduct';
import { get } from 'lodash';
class DeveloperProductView extends React.Component {
  fptiInviteDeveloperClick = () => {
    const { location, fptiHelper } = this.props;
    fptiHelper.fptiClick({
      page: `main:businessweb:mep:dashboard:main:quiz:results`,
      entry_point: get(location, 'search', '').includes('appcenter=true'),
      link: 'invite_developer'
    });
  };
  getBottomView = props => {
    const { developerProducts, toggleProduct, location, fptiHelper } = props,
      maxProducts = Object.keys(developerProducts).length - 1;
    return (
      <React.Fragment>
        <p className="results-uncollapsed-helper-text">
          {getContent('quiz', 'results.developer.helperText')}
        </p>
        <div
          className="developer-product-container"
          style={{ backgroundColor: '#F5F7FA', borderRadius: '2px' }}
        >
          {Object.keys(developerProducts).map((productKey, index) => {
            return (
              <DeveloperProduct
                key={productKey}
                toggleProduct={toggleProduct}
                product={developerProducts[productKey]}
                productName={productKey}
                shouldShowBorderBottom={index !== maxProducts}
                location={location}
                fptiHelper={fptiHelper}
              />
            );
          })}
        </div>
      </React.Fragment>
    );
  };
  render() {
    const { app } = this.props,
      bottomView = this.getBottomView(this.props);
    return (
      <React.Fragment>
        <Row
          className="results-developer"
          style={{ marginLeft: '0px', marginRight: '0px' }}
        >
          <Col className="results-developer-icon-mobile" sm="10%">
            <div
              className="results-icon-container"
              style={{
                background:
                  'url(https://www.paypalobjects.com/ppcp/images/quiz/addDeveloper.svg) center center/28px 28px no-repeat #FFFFFF'
              }}
            />
          </Col>
          <Col className="results-developer-content-mobile" sm="90%">
            <h3 className="results-uncollapsed-title">
              {getContent('quiz', 'results.developer.heading')}
            </h3>
            <p className="results-uncollapsed-subtext">
              {getContent('quiz', 'results.developer.subtext')}
            </p>
            <Button
              onClick={() => {
                this.fptiInviteDeveloperClick();
              }}
              target="_blank"
              href="/commercesetup/addDeveloper"
              style={{ marginTop: '15px', fontSize: '15px', color: '#0070ba' }}
              type="secondary"
            >
              {getContent('quiz', 'results.developer.buttonText')}
            </Button>
            {!get(app, 'deviceInfo.isMobile', false) && bottomView}
          </Col>
        </Row>
        {get(app, 'deviceInfo.isMobile', false) && bottomView}
      </React.Fragment>
    );
  }
}
DeveloperProductView.propTypes = {
  developerProducts: PropTypes.object,
  toggleProduct: PropTypes.func,
  app: PropTypes.object,
  location: PropTypes.object,
  fptiHelper: PropTypes.object
};
export default DeveloperProductView;
